import { experienceList } from "../data.js";
import { localizeDateLabel, localizeField } from "../i18n.js";
import PostRow from "./PostRow.jsx";

export default function ExperiencePage({ t, copy, language }) {
  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>{copy.experience}</h2>
      <div>
        {experienceList.map((post, i) => (
          <PostRow
            key={post.date}
            label={localizeDateLabel(post.date, language)}
            title={localizeField(post, "title", language)}
            subtitle={localizeField(post, "company", language)}
            description={post.description}
            isFirst={i === 0}
            t={t}
            copy={copy}
          />
        ))}
      </div>
    </div>
  );
}
